const TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;
const PREVIEW = (style) =>
  `https://api.mapbox.com/styles/v1/mapbox/${style}/static/10,48,3,0/128x80@2x?access_token=${TOKEN}`;

const MAP_STYLES = [
  {
    id: "dark",
    label: "Sombre",
    url: "mapbox://styles/mapbox/dark-v11",
    preview: PREVIEW("dark-v11"),
  },
  {
    id: "light",
    label: "Clair",
    url: "mapbox://styles/mapbox/light-v11",
    preview: PREVIEW("light-v11"),
  },
  {
    id: "streets",
    label: "Routière",
    url: "mapbox://styles/mapbox/streets-v12",
    preview: PREVIEW("streets-v12"),
  },
  {
    id: "satellite",
    label: "Satellite",
    url: "mapbox://styles/mapbox/satellite-streets-v12",
    preview: PREVIEW("satellite-streets-v12"),
  },
  {
    id: "outdoors",
    label: "courbes de niveau",
    url: "mapbox://styles/mapbox/outdoors-v12",
    preview: PREVIEW("outdoors-v12"),
  },
  {
    id: "navigation",
    label: "Navigation",
    url: "mapbox://styles/mapbox/navigation-night-v1",
    preview: PREVIEW("navigation-night-v1"),
  },
];
export class MapStyleSwitcher {
  constructor(onStyleChange) {
    this._onStyleChange = onStyleChange;
    this._activeId = "satellite";
  }

  onAdd(map) {
    this._map = map;
    this._container = document.createElement("div");
    this._container.className =
      "mapboxgl-ctrl mapboxgl-ctrl-group map-style-ctrl";

    this._container.innerHTML = `
      <button class="map-style-btn" title="Map style" aria-label="Map style">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
             stroke-linecap="round" stroke-linejoin="round" width="18" height="18">
          <rect x="3" y="3" width="7" height="7" rx="1"/>
          <rect x="14" y="3" width="7" height="7" rx="1"/>
          <rect x="3" y="14" width="7" height="7" rx="1"/>
          <rect x="14" y="14" width="7" height="7" rx="1"/>
        </svg>
      </button>
      <div class="map-style-panel">
        ${MAP_STYLES.map(
          (s) => `
          <div class="map-style-tile ${s.id === this._activeId ? "active" : ""}"
               data-style-id="${s.id}" data-style-url="${s.url}">
             <img class="map-style-thumb" src="${s.preview}" alt="${s.label}" loading="lazy" />            <span class="map-style-label">${s.label}</span>
          </div>
        `,
        ).join("")}
      </div>
    `;

    const btn = this._container.querySelector(".map-style-btn");
    const panel = this._container.querySelector(".map-style-panel");

    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      panel.classList.toggle("open");
    });

    document.addEventListener("click", () => panel.classList.remove("open"));
    panel.addEventListener("click", (e) => e.stopPropagation());

    this._container.querySelectorAll(".map-style-tile").forEach((tile) => {
      tile.addEventListener("click", () => {
        this._activeId = tile.dataset.styleId;
        this._container
          .querySelectorAll(".map-style-tile")
          .forEach((t) => t.classList.remove("active"));
        tile.classList.add("active");
        map.setStyle(tile.dataset.styleUrl);
        panel.classList.remove("open");
        this._onStyleChange?.(this._activeId);
      });
    });

    return this._container;
  }

  onRemove() {
    this._container.parentNode?.removeChild(this._container);
    this._map = undefined;
  }
}
